module.exports = __webpack_public_path__ + "img/9788996573135.69c952e2.jpg";